import {segment} from './helpers'

export const groomRentsFreeLearnMoreClicked = () => segment('Groom Rents Free Learn More Clicked')
